import type { FullShipment } from '@fv/client-types'

type RouteGuideShipment = Pick<FullShipment, 'routeGuide'>

export const hasRouteGuide = (shipment?: RouteGuideShipment) =>
  !!shipment?.routeGuide?.status && shipment.routeGuide.status !== 'skipped'

/** Read off the load so the first render already withholds spot quoting for `pending` loads. */
export const isSpotQuotingLocked = (shipment?: RouteGuideShipment) =>
  shipment?.routeGuide?.status === 'pending' ||
  shipment?.routeGuide?.status === 'running' ||
  shipment?.routeGuide?.status === 'awarded'
